import {
    getNotifications,
    getMentionsNotifications,
    deleteNotification
} from "../../services/userServices"
import {
    FETCHING_NOTIFICATIONS_FAILED,
    FETCHING_NOTIFICATIONS_STARTED,
    FETCHING_NOTIFICATIONS_SUCCESS,
    FETCHING_MENTIONS_NOTIFICATIONS_FAILED,
    FETCHING_MENTIONS_NOTIFICATIONS_STARTED,
    FETCHING_MENTIONS_NOTIFICATIONS_SUCCESS,
    UPDATING_NOTIFICATIONS_SUCCESS
} from "./notificationsSlice"

export const deleteNotificationAction = (notificationId) => async (dispatch) => {
    try{
        await dispatch(UPDATING_NOTIFICATIONS_SUCCESS(notificationId));
        await deleteNotification(notificationId);
    } catch (error) {
        console.log(error);
        
    }
}


export const fetchNotifications = (callback) => async (dispatch) => {
    try {
        dispatch(FETCHING_NOTIFICATIONS_STARTED())
        const notifications = await getNotifications();
        dispatch(FETCHING_NOTIFICATIONS_SUCCESS(notifications))
        callback();    
    } catch (error) {
        dispatch(FETCHING_NOTIFICATIONS_FAILED(error.message))
    }
}

export const fetchMentionsNotifications = (offset=0) => async (dispatch) => {
    try {
        dispatch(FETCHING_MENTIONS_NOTIFICATIONS_STARTED())
        const notifications = await getMentionsNotifications(offset);
        dispatch(FETCHING_MENTIONS_NOTIFICATIONS_SUCCESS(notifications))
    } catch (error) {
        dispatch(FETCHING_MENTIONS_NOTIFICATIONS_FAILED(error.message))
    }
}